if (!customElements.get('scrolling-elements')) {
  customElements.define(
    'scrolling-elements',
    class ScrollingElements extends HTMLElement {
      connectedCallback() {
        if (this.offsetParent === null) return;

        const container = this.querySelector('.scrolling-elements-wrap');
        if (!container) return;

        let groups = Array.from(container.querySelectorAll('.scrolling-elements-group'));
        if (!groups.length) return;

        const updateGroups = () => {
          groups = Array.from(container.querySelectorAll('.scrolling-elements-group'));

          const totalGroupWidth = groups.reduce((sum, group) => sum + group.offsetWidth, 0);
          if (!totalGroupWidth) return;

          let currentWidth = totalGroupWidth;

          while (currentWidth < window.innerWidth * 2) {
            const clones = groups.map((group) => {
              const clone = group.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              return clone;
            });

            clones.forEach((clone) => container.appendChild(clone));
            currentWidth += totalGroupWidth;
          }
        };

        updateGroups();

        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            const allGroups = Array.from(container.querySelectorAll('.scrolling-elements-group'));
            allGroups.forEach((group, index) => {
              if (index > 2) group.remove();
            });
            updateGroups();
          }, 150);
        });
      }
    }
  );
}